(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    var isHomepage = document.body.getAttribute('data-template') === 'index' || document.querySelector('main [data-section-type="hero"]') !== null;

    function updateHeaderState() {
      var past = window.scrollY > 72;
      header.classList.toggle('is-scrolled', past);
    }

    if (!isHomepage) {
      header.classList.add('is-solid');
    } else {
      window.addEventListener('scroll', updateHeaderState, { passive: true });
      updateHeaderState();
    }

    var toggle = header.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var backdrop = document.querySelector('[data-mobile-menu-backdrop]');
    var closeBtns = document.querySelectorAll('[data-mobile-menu-close]');

    function closeMenu() {
      if (!menu || !toggle) return;
      menu.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      if (backdrop) {
        backdrop.classList.remove('is-open');
        backdrop.setAttribute('hidden', '');
        backdrop.setAttribute('aria-hidden', 'true');
      }
    }

    function openMenu() {
      if (!menu || !toggle) return;
      menu.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
      header.classList.add('is-solid');
      document.documentElement.style.overflow = 'hidden';
      if (backdrop) {
        backdrop.removeAttribute('hidden');
        backdrop.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () {
          backdrop.classList.add('is-open');
        });
      }
    }

    function isMenuOpen() {
      return menu && !menu.hasAttribute('hidden');
    }

    if (toggle && menu) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (isMenuOpen()) {
          closeMenu();
        } else {
          openMenu();
        }
      });
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeMenu();
      });
    });

    if (backdrop) {
      backdrop.addEventListener('click', function () {
        closeMenu();
      });
    }

    if (menu) {
      menu.addEventListener('click', function (e) {
        var navLink = e.target.closest('[data-mobile-menu] nav a[href]');
        if (navLink) closeMenu();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isMenuOpen()) {
        closeMenu();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      if (typeof window.Splide === 'undefined') return false;
      var hasAutoScroll = window.splide && window.splide.Extensions && window.splide.Extensions.AutoScroll;
      var roots = document.querySelectorAll('[data-marquee]');
      roots.forEach(function (root) {
        if (root.dataset.splideInitialised === '1') return;
        root.dataset.splideInitialised = '1';

        var instance = new Splide(root, {
          type: 'loop',
          drag: 'free',
          focus: 'center',
          perPage: 1,
          autoWidth: true,
          arrows: false,
          pagination: false,
          gap: 0,
          clones: 6,
          autoScroll: { speed: 1, pauseOnHover: false, pauseOnFocus: false },
        });

        if (hasAutoScroll) {
          instance.mount(window.splide.Extensions);
        } else {
          instance.mount();
        }
      });
      return true;
    }

    if (!init()) {
      document.addEventListener('DOMContentLoaded', function () {
        if (init()) return;
        var poll = setInterval(function () {
          if (init()) clearInterval(poll);
        }, 200);
        setTimeout(function () { clearInterval(poll); }, 6000);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
